module.exports = __webpack_public_path__ + "static/img/shanghai.25e504f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/shanghai.png
// module id = gqIS
// module chunks = 1